module.exports = __webpack_public_path__ + "static/media/6.c6a45594.svg";